import { Link } from "react-router-dom";
import React from "react";
import he from "he";
import { useSelector } from "react-redux";

const SiteBreadcrumb = (props) => {
  const { pageTitle, titleClass, parentCategory, pageCategory } = props;
  const { page } = useSelector((state) => state.data);

  // if (!page || !page.data) return <Loader />;

  const htmlContent = page.data["breadcrumb-background"]?.htmlContent || "";
  const decodedHtml = he.decode(htmlContent);

  const regex = /url\(['"]?(.*?)['"]?\)/;
  const match = decodedHtml.match(regex);
  const backgroundUrl = match?.[1];

  // if (!backgroundUrl) return <Loader />;

  const breadcrumbsImgStyle = {
    backgroundImage: `url(${backgroundUrl})`,
    backgroundSize: "cover",
    // backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  };

  return (
    <div className="rs-breadcrumbs" style={breadcrumbsImgStyle}>
      <div className="container">
        <div className="breadcrumbs-inner text-center">
          <h1 className={titleClass || "page-title"}>
            {pageTitle || "Breadcrumbs"}
          </h1>
          <ul>
            <li>
              <Link to="/" className="active">
                {parentCategory || "Home"}
              </Link>
            </li>
            {pageCategory ? (
              <>
                <li>
                  <Link to="/" className="active">
                    {pageCategory}
                  </Link>
                </li>
                <li>{pageTitle}</li>
              </>
            ) : (
              <li>{pageTitle}</li>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SiteBreadcrumb;
